<template>
	<nav>
		<router-link :to="{ name: 'basic-search' }" class="nav-link" exact>{{
			$t("labels.new_search")
		}}</router-link>
		<router-link
			:to="{ name: 'collections' }"
			class="nav-link"
			v-if="hasCollections"
			>{{ $t("menu.collections") }}</router-link
		>
		<!-- <router-link :to="{name: 'resources'}" class="nav-link">{{ $t('menu.resources') }}</router-link> -->
		<router-link :to="{ name: 'saved-list' }" class="nav-link saved">
			<span class="sr-only">{{ $t("menu.saved") }}</span>
			<span class="saved-count" aria-hidden="true">
				<span>{{ saved_count }}</span>
			</span>
			<span
				class="icon-bookmark"
				:class="{ empty: saved_count == 0 }"
				aria-hidden="true"
			></span>
		</router-link>
	</nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Nav",
	computed: {
		...mapGetters({
			site: "search/site",
			saved_count: "list/saved_count",
		}),
		hasCollections() {
			if (!this.site) return false;

			let content = this.$i18n.messages[this.$i18n.locale].collections_page[
				this.site
			];
			return content.collections.length;
		},
	},
};
</script>

<style scoped lang="scss">
$link-underline-offset: 1rem;

nav {
	background: $white;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	height: 70px;
	padding-right: $side-padding;
	padding-bottom: $link-underline-offset;
	box-sizing: border-box;
}
.nav-link {
	margin: 0 15px;
	font-size: 0.925rem;
	text-transform: uppercase;
	font-weight: bold;
	text-decoration: none;
	color: $dark-gray2;

	&:after {
		content: "";
		box-shadow: none;
		position: relative;
		display: block;
		bottom: -17px;
		width: 100%;
		height: 1px;
	}
}

.router-link-active {
	color: $dark-gray1;

	&:after {
		content: "";
		box-shadow: 0px -1px 0px $dark-gray1;
		position: relative;
		display: block;
		bottom: -17px;
		width: 100%;
		height: 1px;
	}

	&.saved:after {
		width: 190%;
	}
}

.saved-count {
	margin-right: 0.625rem;
	color: $dark-gray1;
}

.icon-bookmark {
	position: relative;

	&:after {
		position: absolute;
		content: url("../assets/images/icon-bookmark-on.svg");
		top: -9px;
		left: 0;
	}

	&.empty:after {
		position: absolute;
		content: url("../assets/images/icon-bookmark-off.svg");
		top: -9px;
		left: 0;
	}
}

@media (max-width: $mq-max-width-tablet) {
	nav {
		display: none;
	}
}

@media print {
	nav {
		display: none;
	}
}
</style>
